var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.subMenuList),function(subMenu){return _c('mds-list-group-item',{attrs:{"active":subMenu.isActive,"text":subMenu.name},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.setActiveStatus(subMenu)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }